<template>
  <div
    class="two-columns-widget grid"
    :class="{ 'without-titles': withoutTitles }"
  >
    <div
      v-if="widget.left_column_title"
      class="left-col title t-h5"
      v-html="nbsp(widget.left_column_title)"
    />
    <div
      class="left-col text t-p-m-160"
      v-html="nbsp(widget.left_column_text)"
    />
    <div
      v-if="widget.right_column_title"
      class="right-col title t-h5"
      v-html="nbsp(widget.right_column_title)"
    />
    <div
      class="right-col text t-p-m-160"
      v-html="nbsp(widget.right_column_text)"
    />
  </div>
</template>

<script setup lang="ts">
import type { PublicTwoColumnsTextWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicTwoColumnsTextWidget>>()

const withoutTitles = computed(
  () => !props.widget.left_column_title && !props.widget.right_column_title
)
</script>

<style scoped lang="scss">
.two-columns-widget {
  &:not(.without-titles) {
    @include media-up(md) {
      grid-template-rows: max-content rem(30px) max-content;

      > .title {
        grid-row: 1/2;
      }

      > .text {
        grid-row: 3/4;
      }
    }
  }

  &.without-titles {
    @include media-up(md) {
      grid-template-rows: max-content;
    }
  }
}

.left-col {
  @include media-column(
    (
      xs: 12,
      md: 6 0
    )
  );
}

.right-col {
  @include media-column(
    (
      xs: 12,
      md: 6 6
    )
  );
}

.text {
  color: $layout-text-02;

  :deep(ul) {
    @include custom-ul;
  }
}

.title,
.text {
  &:not(:last-child) {
    @include media-down(md) {
      margin-bottom: rem(30px);
    }
  }
}

.left-col.text {
  @include media-down(md) {
    margin-bottom: 64px;
  }
}
</style>
